const STRIPE_TOKEN_US = document.documentElement.dataset.stripeTokenUs;
const STRIPE_TOKEN_CA = document.documentElement.dataset.stripeTokenCa;
const CSRF_TOKEN = document.head.querySelector('[name=csrf-token]').content;
const ENV = document.documentElement.dataset.env;
const PATH = document.documentElement.dataset.urlPath;
const QUOTES_API = PATH + '/api/v1/quotes';
const ORDERS_API = PATH + '/api/v1/orders';
const LEADS_API = PATH + '/api/v1/email_lead';
const MIX_PANEL_TOKEN =  document.documentElement.dataset.mixpanelToken;
const HVAC_MONITORING = 'hvac_monitoring';
const HANDY_BLUE = '#0BB8E3';

module.exports = {
  STRIPE_TOKEN_US: STRIPE_TOKEN_US,
  STRIPE_TOKEN_CA: STRIPE_TOKEN_CA,
  CSRF_TOKEN: CSRF_TOKEN,
  QUOTES_API: QUOTES_API,
  ORDERS_API: ORDERS_API,
  LEADS_API: LEADS_API,
  MIX_PANEL_TOKEN: MIX_PANEL_TOKEN,
  ENV: ENV,
  PATH: PATH,
  HVAC_MONITORING: HVAC_MONITORING,
  HANDY_BLUE: HANDY_BLUE,
}
